export default __webpack_public_path__ + "static/media/ellipse30Map1.fc80e660.svg";